import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Alert, Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import { createShowcaseContact } from './api';
import classNames from 'classnames';

function ShowcaseContactForm({ onAddContact }) {
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const renderInput = (label, key, required = false) => (
    <FormGroup>
      <ControlLabel className={classNames({ required })}>
        {label}
        {required && <abbr className="text-danger" title="required"> *</abbr>}
      </ControlLabel>
      <FormControl
        placeholder={label}
        required={required}
        value={formData[key] || ''}
        onChange={e => setFormData({ ...formData, [key]: e.target.value })}
      />
    </FormGroup>
  );

  const paramValue = (param, fallback = null) => {
    const value = param?.strip();
    return value || fallback;
  };

  const createParams = () => ({
    firstName: paramValue(formData.firstName, ''),
    lastName: paramValue(formData.lastName, ''),
    email: paramValue(formData.email),
    jobTitle: paramValue(formData.jobTitle),
    licenseNumber: paramValue(formData.licenseNumber)
  });

  const handleSubmit = () => {
    setSaving(true);

    createShowcaseContact(createParams()).then((data) => {
      onAddContact(data);
    }).catch(setErrors).finally(() => setSaving(false));
  };

  return (
    <React.Fragment>
      {errors.length > 0 && (
        <Alert bsStyle="danger" className="text-left">
          <div><strong>Whoops -</strong> There were errors in the form that prevented saving.</div>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
      {renderInput('First Name', 'firstName', true)}
      {renderInput('Last Name', 'lastName', true)}
      {renderInput('Email', 'email')}
      {renderInput('Job Title', 'jobTitle')}
      {renderInput('License Number', 'licenseNumber')}
      <Button bsStyle="primary" disabled={saving} onClick={handleSubmit}>Create or Save</Button>
    </React.Fragment>
  );
}

ShowcaseContactForm.propTypes = {
  onAddContact: PropTypes.func.isRequired
};

export default ShowcaseContactForm;
